<div class="container-fluid">
  <div class="header">
    <h2>Consultar Valores</h2>
    <p class="text-muted">Consulta de tabela de valores por microserviço e fornecedor</p>
  </div>

  <!-- Filtros -->
  <div class="filtros-container mb-4">
    <div class="row align-items-end">
      <div class="col-md-5">
        <div class="form-group">
          <label for="filtroMicroservicoTexto">Microserviço</label>
          <input
            id="filtroMicroservicoTexto"
            type="text"
            class="form-control"
            [(ngModel)]="filtroMicroservicoTexto"
            placeholder="Digite item ou descrição do microserviço">
        </div>
      </div>
      <div class="col-md-5">
        <div class="form-group">
          <label for="idFornecedorFiltro">Fornecedor</label>
          <select
            id="idFornecedorFiltro"
            class="form-control"
            [(ngModel)]="idFornecedorFiltro">
            <option value="">Todos</option>
            <option *ngFor="let fornecedor of fornecedores" [value]="fornecedor.id">
              {{ fornecedor.text }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-md-2">
        <div class="form-group">
          <label class="invisible d-block">Ações</label>
          <button type="button" class="btn btn-primary me-2" (click)="buscar()">
            <i class="fa fa-search"></i> Buscar
          </button>
          <button type="button" class="btn btn-outline-secondary" (click)="limparFiltros()">
            <i class="fa fa-eraser"></i>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Loading -->
  <div *ngIf="loading" class="text-center py-4">
    <i class="fa fa-spinner fa-spin fa-2x text-primary mb-3"></i>
    <p class="text-muted">Carregando tabela de valores...</p>
  </div>

  <!-- Error Message -->
  <div *ngIf="errorMessage" class="alert alert-danger" role="alert">
    <i class="fa fa-exclamation-triangle"></i>
    {{ errorMessage }}
  </div>

  <!-- Tabela -->
  <div class="table-container" *ngIf="!loading">
    <div class="table-responsive">
      <table class="table table-hover">
        <thead class="table-light">
          <tr>
            <th>Título</th>
            <th>Descrição</th>
            <th>Parceiro</th>
            <th>Vigência</th>
            <th>Valor</th>
            <th>Obs.</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of tabelasValoresPaginadas">
            <td>{{ item.itemMicroservico || '-' }}</td>
            <td>{{ item.descricaoMicroservico || '-' }}</td>
            <td>{{ item.nomeFornecedor || '-' }}</td>
            <td>{{ formatarVigencia(item) }}</td>
            <td>{{ formatarMoeda(item.valor) }}</td>
            <td>{{ item.observacoes || '-' }}</td>
            <td>
              <span
                class="badge"
                [class]="getStatusClass(item.isAtivo)"
                (click)="alterarStatus(item)"
                style="cursor: pointer;"
                [title]="'Clique para alterar status'">
                {{ item.isAtivo ? 'Ativo' : 'Inativo' }}
              </span>
            </td>
          </tr>
        </tbody>
      </table>
      
      <div class="no-data" *ngIf="tabelasValores.length === 0">
        <div class="text-center py-4">
          <i class="fa fa-table fa-3x text-muted mb-3"></i>
          <h5 class="text-muted">Nenhum valor encontrado</h5>
          <p class="text-muted">Tente ajustar os filtros de busca.</p>
        </div>
      </div>
    </div>

    <div class="d-flex justify-content-between align-items-center mt-3 px-3 pb-3" *ngIf="tabelasValores.length > 0">
      <div class="d-flex align-items-center">
        <span class="me-2">Itens por página:</span>
        <select class="form-control form-control-sm" style="width: 90px;" [(ngModel)]="itensPorPagina" (change)="alterarItensPorPagina()">
          <option [ngValue]="5">5</option>
          <option [ngValue]="10">10</option>
          <option [ngValue]="20">20</option>
          <option [ngValue]="50">50</option>
        </select>
      </div>

      <div class="text-muted">
        Página {{ paginaAtual }} de {{ totalPaginas || 1 }}
      </div>

      <div class="d-flex">
        <button class="btn btn-outline-secondary btn-sm me-2" (click)="paginaAnterior()" [disabled]="paginaAtual <= 1">Anterior</button>
        <button class="btn btn-outline-secondary btn-sm" (click)="proximaPagina()" [disabled]="paginaAtual >= totalPaginas">Próxima</button>
      </div>
    </div>
  </div>
</div> 